import React, { memo } from 'react';
import { Link } from 'react-router-dom';

const IsSentRendererComponent = ({ value, isVisible }) => {
  if (!isVisible) return null;

  return (
    <>
      <span>Yes&nbsp;</span>
      <Link rel="noreferrer" target="_blank" to={`/mailing-logs/${value}`}>
        View Details
      </Link>
    </>
  );
};

export const IsSentRenderer = memo(IsSentRendererComponent);
